import { render, staticRenderFns } from "./CancelAppointments.vue?vue&type=template&id=4fa18568&scoped=true"
import script from "./CancelAppointments.vue?vue&type=script&lang=js"
export * from "./CancelAppointments.vue?vue&type=script&lang=js"
import style0 from "./CancelAppointments.vue?vue&type=style&index=0&id=4fa18568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa18568",
  null
  
)

export default component.exports